import React, { useState, useEffect } from 'react'
import './App.css';
import greenLogo from './greenLogo.png';
import CustomSlider from "./CustomSlider";

export default function App()
{
  const [topic, setTopic] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [loginError, setLoginError] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCopyButton, setShowCopyButton] = useState(false);
  const [sliderValue, setSliderValue] = useState(1);
  const [multiplier, setMultiplier] = useState(1);

  useEffect(() =>
  {
    const storedUsername = localStorage.getItem("username");
    const storedPassword = localStorage.getItem("password");

    if (storedUsername && storedPassword)
    {
      setUsername(storedUsername);
      setPassword(storedPassword);
      setIsLoggedIn(true);
    }
  }, []);

  const handleQuestionsSlider = (newValue) =>
  {
    setSliderValue(newValue);
  };

  const handleButtonClick = (newMultiplier) =>
  {
    setMultiplier(newMultiplier);
  };

  async function fetchData()
  {
    try
    {
      const sliderNumber = parseInt(sliderValue, 10);
      const tokensValue = 50 * multiplier * sliderNumber;
      console.log("sliderNumber", sliderNumber);
      console.log("tokensValue", tokensValue);

      const response = await fetch('https://gen-ai-09d608147857.herokuapp.com/api/chat', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          topic,
          sliderValue,
          tokensValue,
        }),
      });

      if (response.ok)
      {
        setFetchError("");
        const reader = response.body.getReader();
        let receivedMessage = ""; // Accumulate the message
        while (true)
        {
          const { done, value } = await reader.read();
          if (done)
          {
            break;
          }
          const chunk = new TextDecoder().decode(value);
          receivedMessage += chunk; // Accumulate chunk into receivedMessage
          setMessages([receivedMessage]); // Set messages to update UI
        }
      } else
      {
        setMessages([]);
        setFetchError('An error occurred while fetching data. Please change prompt and try again.');
      }
    } catch (error)
    {
      setMessages([]);
      console.error(error);
      setFetchError('OpenAI server error. Please change prompt and try again.');
    }
  }

  const handleClick = async (event) =>
  {
    event.preventDefault();
    setLoading(true);
    setMessages([]);
    setShowCopyButton(false);
    await fetchData();
    setShowCopyButton(true);
    setLoading(false);
  };

  const handleCopyToClipboard = () =>
  {
    const formattedText = messages.map(message =>
    {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = message;
      const headers = Array.from(tempDiv.querySelectorAll('th')).map(header => header.innerText).join('\t');
      const rows = Array.from(tempDiv.querySelectorAll('tr')).map(row =>
      {
        return Array.from(row.querySelectorAll('td')).map(cell => cell.innerText).join('\t');
      });
      return [headers, ...rows].join('\n');
    }).join('\n');

    navigator.clipboard.writeText(formattedText)
      .then(() =>
      {
        console.log("Copied to clipboard successfully!");
      })
      .catch(err =>
      {
        console.error("Failed to copy: ", err);
      });
  };

  const handleLogin = async (event) =>
  {
    event.preventDefault();
    try
    {
      const response = await fetch('https://gen-ai-09d608147857.herokuapp.com/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok)
      {
        const data = await response.json();
        console.log(data.message);
        setPassword(data.password);
        setUsername(data.username);
        setIsLoggedIn(true);
        setLoginError("");
        localStorage.setItem("username", data.username);
        localStorage.setItem("password", data.password);
      } else
      {
        const errorData = await response.json();
        console.error(errorData.message);
        setLoginError('Invalid username or password');
      }
    } catch (error)
    {
      console.error('An error occurred:', error);
    }
  };
  const handleLogout = () =>
  {
    setIsLoggedIn(false);
    setUsername('');
    setPassword('');
    localStorage.removeItem("username");
    localStorage.removeItem("password");
  };

  const renderMessageContent = (message) =>
  {
    const cleanedMessage = message.replace(/```html/g, '').replace(/-+/g, '').replace(/```/g, '').trim();
    const isHtmlTable = cleanedMessage.includes('<table>');

    if (isHtmlTable)
    {
      return (
        <div className="table-container" dangerouslySetInnerHTML={{ __html: cleanedMessage }} />
      );
    }
    return (
      <div>
        {cleanedMessage.split("\n").map((line, lineIndex) => (
          <span key={lineIndex}>
            {line}
            <br />
          </span>
        ))}
      </div>
    );
  };

  if (!isLoggedIn)
  {
    return (
      <div>
        <div className="login">
          <nav className='navbar'>
            <img className='logo' src={greenLogo} alt='logo' />
          </nav>
          <h1>Log In</h1>
          <form onSubmit={handleLogin} className="login-form">
            <label htmlFor="username">Username:</label>
            <input
              className="username"
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <label htmlFor="password">Password:</label>
            <input
              className="password"
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit" className="submit">
              Login
            </button>
            {loginError && <p className="error">{loginError}</p>}
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className='App'>
      <nav className='navbar'>
        <img className='logo' src={greenLogo} alt='logo' />
      </nav>
      <section className="form" id="formSection">
        <form className="formInput" onSubmit={handleClick}>
          <h1>ConcepTest Generator</h1>
          <section className="internal">
            <label htmlFor="topic">Please Enter a Topic:</label>
            <p className="warning">
              <em>example: biology</em>
            </p>
            <input
              className="topic"
              type="text"
              id="topic"
              value={topic}
              onChange={(e) => setTopic(e.target.value)} // Update the topic state as the user types
              required
            />
            <div className="sliderContainer">
              <p className="requirement">Adjust the number of questions:</p>
              <CustomSlider
                min={1}
                max={5}
                value={sliderValue}
                onChange={handleQuestionsSlider}
              />
            </div>
            {/* <div>
              <p className="requirement">Adjust Word Count:</p>
              <button
                type="button"
                onClick={() => handleButtonClick(2)}
                className={`word ${multiplier === 2 && "selected"}`}
              >
                Concise
              </button>
              <button
                type="button"
                onClick={() => handleButtonClick(3)}
                className={`word ${multiplier === 3 && "selected"}`}
              >
                Perfect
              </button>
              <button
                type="button"
                onClick={() => handleButtonClick(4)}
                className={`word ${multiplier === 4 && "selected"}`}
              >
                Wordy
              </button>
            </div> 
            */}
            <p className="warning">
              Note: This is a free research preview. It may occasionally produce inaccurate information about people, places, or facts. If the table doesn’t render correctly, please click submit again.
            </p>
            {/* Submit button, if loading is true, display "Generating...", else display "Submit"*/}
            <button type="submit" disabled={loading}>
              {loading ? "Generating..." : "Submit"}
            </button>
            {fetchError && <p className='fetchError'>{fetchError}</p>}
          </section>
        </form>
        <section className="message-container">
          <div className="buttonContainer">
            <button className="logoutButton" onClick={handleLogout}>
              Logout
            </button>
          </div>
          <div className="title">
            <h3>Result</h3>
          </div>
          {showCopyButton && (
            <div className="tooltip" onClick={handleCopyToClipboard}>
              <i className="fa-regular fa-clipboard"></i>
            </div>
          )}
          <div className="message">
            {messages.map((message, index) => (
              <div key={index} className="message-item">
                {renderMessageContent(message)}
              </div>
            ))}
          </div>
        </section>
      </section >
    </div >
  )
}
